<div class="title">{{data.dataToSave.validationType === 'aprove' ? 'Aprovar' : 'Rejeitar'}} Perfil</div>

<div class="text" [innerHTML]="message"></div>

<div class="message" *ngIf="started">
  <form [formGroup]="form" novalidate (keydown.enter)="$event.preventDefault()">
    <mat-form-field class="full-width">
      <mat-label>Deixe um comentário!</mat-label>
      <textarea class="input-message" matInput formControlName="message"></textarea>
    </mat-form-field>

  </form>
</div>

<div class="actions">
  <button mat-raised-button (click)="cancel()">CANCELAR</button>
  <button mat-raised-button (click)="confirm()">VAMOS LÁ!</button>
</div>
